// Default anonymous LaunchDarkly context used to initialize the client before
// the borrower is identified. Mirrors the reggora-lender-frontend setup
// (launchdarkly-react-client-sdk v3 multi-context API).
const defaultAnonymousContext = {
  kind: 'user',
  anonymous: true,
  key: 'unidentified_init_user',
  type: 'LENDER',
}

export { defaultAnonymousContext }
